import React from 'react'
import { Button, Col } from 'react-bootstrap'
import './project.css'

const ProjectCard = (props) => {
  return (
    <Col lg={4} md={4} sm={12} className="blog-col"> {/* Adding custom class to Col */}
    
    <a href={props.link} style={{marginBottom:"10px"}}  target="_blank">
    <img src={props.image} alt="" style={{ width: "100%", padding: "1rem", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",margin:"1rem 0" }} /> 
    </a>

  
  
  </Col>
  )
}

export default ProjectCard
